import cn from 'classnames';
import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useState } from 'react';

import BodyText from '@ui/atoms/BodyText';
import Eyebrow from '@ui/atoms/Eyebrow';
import { Minus, Plus } from '@ui/atoms/icons';

import * as $ from './LinkGroup.styled';

interface IMenuProps {
	link_group_key: any;
	menu_key: string;
}

interface Props {
	menu: IMenuProps;
}

interface ILink {
	image: string;
	label: string;
	url: string;
	target: string;
	discrete?: boolean;
}

interface ILinkGroup {
	link_group_key: string;
	title: string;
	links: ILink[];
}

const LinkGroup: FC<Props> = ({ menu }) => {
	const [collapsed, setCollapsed] = useState(false);

	const { butterCollection } = useStaticQuery(graphql`
		query WSMenuQuery {
			butterCollection(id: { eq: "link_group" }) {
				value {
					link_group_key
					title
					links {
						image
						label
						url
						target
						discrete
					}
				}
			}
		}
	`);

	const menuItem: ILinkGroup = butterCollection.value.find(
		(m: ILinkGroup) => m.link_group_key === menu.link_group_key
	);

	return (
		<div>
			{menuItem && (
				<$.FooterLinkColumn>
					<button aria-label={menuItem.title} onClick={() => setCollapsed(!collapsed)}>
						<Eyebrow size="xs">
							{menuItem.title}
							{collapsed ? <Minus /> : <Plus />}
						</Eyebrow>
					</button>
					{menuItem.links && (
						<div
							className={cn('linksWrapper', {
								['collapsed']: collapsed,
							})}>
							{menuItem.links.length &&
								menuItem.links.map((l: ILink, i: number) => (
									<$.StyledStaticLink
										key={i}
										href={`
											${!l.discrete ? process.env.GATSBY_MARKETING_SITE_BASE_URL : ''}${l.url}
										`}
										target={l.target}>
										<BodyText>{l.label}</BodyText>
									</$.StyledStaticLink>
								))}
						</div>
					)}
				</$.FooterLinkColumn>
			)}
		</div>
	);
};

export default LinkGroup;
